import React from 'react';

const Logo = (props) => (
  <div
    style={{
      position: 'absolute',
      left: '0px',
      top: '22px',
      fontFamily: "'Work Sans' !important",
      fontStyle: 'normal',
      fontSize: '22px',
      lineHeight: '28px',
      letterSpacing: '0.002em',
      color: '#142A39',
      padding: '0px 10px',
    }}
  >
    <b>Kardia</b>Complete
  </div>
);

export default Logo;
